import React from "react";
import { LongTextLabel } from "@sscs/ui";
import { buildRlPurl } from "@sscs/utils";
import { SoftwareInfo } from "Components";
import { MoveData } from "../../../types";

type OverviewProps = {
  moveData: MoveData;
  fileName: string;
  predecessorVersion?: string;
  showForce: boolean;
  showReplace: boolean;
};

const Overview = ({
  moveData,
  predecessorVersion,
  fileName,
  showForce,
  showReplace,
}: OverviewProps): React.JSX.Element => {
  const destinationPurl = buildRlPurl(
    moveData.project_name,
    moveData.package_name,
    moveData.version,
  );

  return (
    <SoftwareInfo.Overview
      softwareInfo={moveData}
      isVersion
      predecessorVersion={predecessorVersion}
      showForce={showForce}
      showReplace={showReplace}
      leadingList={[
        {
          Moving: fileName,
          "Moving to": (
            <code>
              <LongTextLabel label={destinationPurl} />
            </code>
          ),
        },
      ]}
    />
  );
};

export default Overview;
